import { Question } from '../types';

export const exceptionsQuestions: Question[] = [
  {
    id: 'ex1',
    text: 'According to Al-Ajrumiyyah, what is الاستثناء (the exception)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that is excluded from a general rule', isCorrect: true },
      { id: 'b', text: 'The noun that is included in a general rule', isCorrect: false },
      { id: 'c', text: 'The verb that is excluded from a general rule', isCorrect: false },
      { id: 'd', text: 'The verb that is included in a general rule', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الاستثناء (the exception) as the noun that is excluded from a general rule, as in جاء القوم إلا زيداً (The people came except Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex2',
    text: 'According to Al-Ajrumiyyah, what are the particles of exception?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'إلا (illa)', isCorrect: true },
      { id: 'b', text: 'غير (ghayr)', isCorrect: true },
      { id: 'c', text: 'سوى (siwa)', isCorrect: true },
      { id: 'd', text: 'خلا (khala)', isCorrect: true },
      { id: 'e', text: 'عدا (\'ada)', isCorrect: true },
      { id: 'f', text: 'حاشا (hasha)', isCorrect: true },
      { id: 'g', text: 'بل (bal)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the particles of exception are: إلا (illa), غير (ghayr), سوى (siwa), خلا (khala), عدا (\'ada), and حاشا (hasha).',
    topic: 'exceptions'
  },
  {
    id: 'ex3',
    text: 'According to Al-Ajrumiyyah, what is المستثنى (the excepted)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that comes before the particle of exception', isCorrect: false },
      { id: 'b', text: 'The noun that comes after the particle of exception', isCorrect: true },
      { id: 'c', text: 'The particle of exception itself', isCorrect: false },
      { id: 'd', text: 'The sentence that contains the exception', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المستثنى (the excepted) as the noun that comes after the particle of exception, as in جاء القوم إلا زيداً (The people came except Zayd), where زيداً is المستثنى (the excepted).',
    topic: 'exceptions'
  },
  {
    id: 'ex4',
    text: 'According to Al-Ajrumiyyah, what is المستثنى منه (the excepted from)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that comes before the particle of exception', isCorrect: true },
      { id: 'b', text: 'The noun that comes after the particle of exception', isCorrect: false },
      { id: 'c', text: 'The particle of exception itself', isCorrect: false },
      { id: 'd', text: 'The sentence that contains the exception', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المستثنى منه (the excepted from) as the noun that comes before the particle of exception, as in جاء القوم إلا زيداً (The people came except Zayd), where القوم is المستثنى منه (the excepted from).',
    topic: 'exceptions'
  },
  {
    id: 'ex5',
    text: 'According to Al-Ajrumiyyah, what are the types of الاستثناء (the exception)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الاستثناء المتصل (the connected exception)', isCorrect: true },
      { id: 'b', text: 'الاستثناء المنقطع (the disconnected exception)', isCorrect: true },
      { id: 'c', text: 'الاستثناء المفرغ (the emptied exception)', isCorrect: true },
      { id: 'd', text: 'الاستثناء المتصف (the described exception)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the types of الاستثناء (the exception) are: الاستثناء المتصل (the connected exception), الاستثناء المنقطع (the disconnected exception), and الاستثناء المفرغ (the emptied exception).',
    topic: 'exceptions'
  },
  {
    id: 'ex6',
    text: 'According to Al-Ajrumiyyah, what is الاستثناء المتصل (the connected exception)?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the excepted is of the same kind as the excepted from', isCorrect: true },
      { id: 'b', text: 'When the excepted is not of the same kind as the excepted from', isCorrect: false },
      { id: 'c', text: 'When the excepted from is not mentioned', isCorrect: false },
      { id: 'd', text: 'When the excepted is mentioned twice', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الاستثناء المتصل (the connected exception) as when the excepted is of the same kind as the excepted from, as in جاء القوم إلا زيداً (The people came except Zayd), where زيداً is of the same kind as القوم.',
    topic: 'exceptions'
  },
  {
    id: 'ex7',
    text: 'According to Al-Ajrumiyyah, what is الاستثناء المنقطع (the disconnected exception)?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the excepted is of the same kind as the excepted from', isCorrect: false },
      { id: 'b', text: 'When the excepted is not of the same kind as the excepted from', isCorrect: true },
      { id: 'c', text: 'When the excepted from is not mentioned', isCorrect: false },
      { id: 'd', text: 'When the excepted is mentioned twice', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الاستثناء المنقطع (the disconnected exception) as when the excepted is not of the same kind as the excepted from, as in جاء القوم إلا حماراً (The people came except a donkey), where حماراً is not of the same kind as القوم.',
    topic: 'exceptions'
  },
  {
    id: 'ex8',
    text: 'According to Al-Ajrumiyyah, what is الاستثناء المفرغ (the emptied exception)?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the excepted is of the same kind as the excepted from', isCorrect: false },
      { id: 'b', text: 'When the excepted is not of the same kind as the excepted from', isCorrect: false },
      { id: 'c', text: 'When the excepted from is not mentioned', isCorrect: true },
      { id: 'd', text: 'When the excepted is mentioned twice', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الاستثناء المفرغ (the emptied exception) as when the excepted from is not mentioned, as in ما جاء إلا زيد (No one came except Zayd), where the excepted from is not mentioned.',
    topic: 'exceptions'
  },
  {
    id: 'ex9',
    text: 'According to Al-Ajrumiyyah, when is the excepted in the نصب (accusative) case?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'In a complete positive sentence with إلا (illa)', isCorrect: true },
      { id: 'b', text: 'In a complete negative sentence with إلا (illa)', isCorrect: true },
      { id: 'c', text: 'In an incomplete sentence with إلا (illa)', isCorrect: false },
      { id: 'd', text: 'With غير (ghayr) or سوى (siwa)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the excepted is in the نصب (accusative) case in a complete positive sentence with إلا (illa) and in a complete negative sentence with إلا (illa).',
    topic: 'exceptions'
  },
  {
    id: 'ex10',
    text: 'According to Al-Ajrumiyyah, when is the excepted according to the governing agent before إلا (illa)?',
    type: 'single',
    options: [
      { id: 'a', text: 'In a complete positive sentence with إلا (illa)', isCorrect: false },
      { id: 'b', text: 'In a complete negative sentence with إلا (illa)', isCorrect: false },
      { id: 'c', text: 'In an incomplete sentence with إلا (illa)', isCorrect: true },
      { id: 'd', text: 'With غير (ghayr) or سوى (siwa)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the excepted is according to the governing agent before إلا (illa) in an incomplete sentence with إلا (illa), as in ما جاء إلا زيد (No one came except Zayd), where زيد is in the nominative case because it is the subject.',
    topic: 'exceptions'
  },
  {
    id: 'ex11',
    text: 'According to Al-Ajrumiyyah, what is the case of المستثنى (the excepted) after غير (ghayr) or سوى (siwa)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: true },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the المستثنى (the excepted) after غير (ghayr) or سوى (siwa) is always in the مجرور (genitive) case by إضافة (annexation), as in جاء القوم غير زيدٍ (The people came except Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex12',
    text: 'According to Al-Ajrumiyyah, what is the case of خلا (khala), عدا (\'ada), and حاشا (hasha)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'They can be أفعال (verbs)', isCorrect: true },
      { id: 'b', text: 'They can be حروف جر (prepositions)', isCorrect: true },
      { id: 'c', text: 'They can be أسماء (nouns)', isCorrect: false },
      { id: 'd', text: 'They can be ظروف (adverbs)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that خلا (khala), عدا (\'ada), and حاشا (hasha) can be أفعال (verbs) or حروف جر (prepositions).',
    topic: 'exceptions'
  },
  {
    id: 'ex13',
    text: 'According to Al-Ajrumiyyah, when are خلا (khala), عدا (\'ada), and حاشا (hasha) considered أفعال (verbs)?',
    type: 'single',
    options: [
      { id: 'a', text: 'When they are preceded by ما (ma)', isCorrect: true },
      { id: 'b', text: 'When they are followed by a noun in the genitive case', isCorrect: false },
      { id: 'c', text: 'When they are at the beginning of a sentence', isCorrect: false },
      { id: 'd', text: 'When they are followed by a verb', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that خلا (khala), عدا (\'ada), and حاشا (hasha) are considered أفعال (verbs) when they are preceded by ما (ma), as in جاء القوم ما خلا زيداً (The people came, not including Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex14',
    text: 'According to Al-Ajrumiyyah, what is the case of the noun after خلا (khala), عدا (\'ada), and حاشا (hasha) when they are considered أفعال (verbs)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the noun after خلا (khala), عدا (\'ada), and حاشا (hasha) when they are considered أفعال (verbs) is in the منصوب (accusative) case, as in جاء القوم ما خلا زيداً (The people came, not including Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex15',
    text: 'According to Al-Ajrumiyyah, what is the case of the noun after خلا (khala), عدا (\'ada), and حاشا (hasha) when they are considered حروف جر (prepositions)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: true },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the noun after خلا (khala), عدا (\'ada), and حاشا (hasha) when they are considered حروف جر (prepositions) is in the مجرور (genitive) case, as in جاء القوم خلا زيدٍ (The people came except Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex16',
    text: 'According to Al-Ajrumiyyah, what happens to المستثنى (the excepted) after إلا (illa) in a negative incomplete sentence?',
    type: 'single',
    options: [
      { id: 'a', text: 'It is always منصوب (accusative)', isCorrect: false },
      { id: 'b', text: 'It is always مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'It is according to what the sentence requires', isCorrect: true },
      { id: 'd', text: 'It is always مجرور (genitive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المستثنى (the excepted) after إلا (illa) in a negative incomplete sentence is according to what the sentence requires, as in ما قام إلا زيدٌ (No one stood except Zayd), where زيدٌ is in the nominative case because it is the subject.',
    topic: 'exceptions'
  },
  {
    id: 'ex17',
    text: 'According to Al-Ajrumiyyah, when can المستثنى (the excepted) after إلا (illa) be in the nominative case?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'In a negative incomplete sentence when it is the subject', isCorrect: true },
      { id: 'b', text: 'In a negative incomplete sentence when it is the predicate', isCorrect: true },
      { id: 'c', text: 'In a complete positive sentence', isCorrect: false },
      { id: 'd', text: 'In a complete negative sentence', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that المستثنى (the excepted) after إلا (illa) can be in the nominative case in a negative incomplete sentence when it is the subject or the predicate, as in ما قام إلا زيدٌ (No one stood except Zayd) and ما زيدٌ إلا قائمٌ (Zayd is only standing).',
    topic: 'exceptions'
  },
  {
    id: 'ex18',
    text: 'According to Al-Ajrumiyyah, when can المستثنى (the excepted) after إلا (illa) be in the accusative case?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'In a complete positive sentence', isCorrect: true },
      { id: 'b', text: 'In a complete negative sentence when it is not a substitution (بدل)', isCorrect: true },
      { id: 'c', text: 'In a negative incomplete sentence', isCorrect: false },
      { id: 'd', text: 'In a positive incomplete sentence', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that المستثنى (the excepted) after إلا (illa) can be in the accusative case in a complete positive sentence, as in جاء القوم إلا زيداً (The people came except Zayd), and in a complete negative sentence when it is not a substitution (بدل), as in ما جاء القوم إلا زيداً (The people did not come except Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex19',
    text: 'According to Al-Ajrumiyyah, what is the case of غير (ghayr) and سوى (siwa) in an exception?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that غير (ghayr) and سوى (siwa) in an exception are in the same case as المستثنى (the excepted) after إلا (illa) would be in the same sentence, as in جاء القوم غيرَ زيدٍ (The people came except Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex20',
    text: 'According to Al-Ajrumiyyah, what is the case of خلا (khala), عدا (\'ada), and حاشا (hasha) when they are preceded by ما (ma)?',
    type: 'single',
    options: [
      { id: 'a', text: 'They are verbs and what comes after them is in the accusative case', isCorrect: true },
      { id: 'b', text: 'They are prepositions and what comes after them is in the genitive case', isCorrect: false },
      { id: 'c', text: 'They are nouns and what comes after them is in the nominative case', isCorrect: false },
      { id: 'd', text: 'They are particles and what comes after them is in the jussive case', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that خلا (khala), عدا (\'ada), and حاشا (hasha) when they are preceded by ما (ma) are verbs and what comes after them is in the accusative case, as in جاء القوم ما خلا زيداً (The people came, not including Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex21',
    text: 'According to Al-Ajrumiyyah, what is the case of خلا (khala), عدا (\'ada), and حاشا (hasha) when they are not preceded by ما (ma)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'They can be verbs and what comes after them is in the accusative case', isCorrect: true },
      { id: 'b', text: 'They can be prepositions and what comes after them is in the genitive case', isCorrect: true },
      { id: 'c', text: 'They can be nouns and what comes after them is in the nominative case', isCorrect: false },
      { id: 'd', text: 'They can be particles and what comes after them is in the jussive case', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that خلا (khala), عدا (\'ada), and حاشا (hasha) when they are not preceded by ما (ma) can be either verbs and what comes after them is in the accusative case, or prepositions and what comes after them is in the genitive case, as in جاء القوم خلا زيداً or جاء القوم خلا زيدٍ (The people came except Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex22',
    text: 'According to Al-Ajrumiyyah, what is the difference between تام موجب (complete positive), تام غير موجب (complete negative), and ناقص (incomplete) in the context of exceptions?',
    type: 'single',
    options: [
      { id: 'a', text: 'تام موجب is a positive sentence with a mentioned المستثنى منه, تام غير موجب is a negative sentence with a mentioned المستثنى منه, and ناقص is a sentence without a mentioned المستثنى منه', isCorrect: true },
      { id: 'b', text: 'تام موجب is a positive sentence, تام غير موجب is a negative sentence, and ناقص is a question', isCorrect: false },
      { id: 'c', text: 'تام موجب is a sentence with إلا, تام غير موجب is a sentence with غير, and ناقص is a sentence with سوى', isCorrect: false },
      { id: 'd', text: 'تام موجب is a sentence with a verb, تام غير موجب is a sentence without a verb, and ناقص is a sentence with a missing subject', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that تام موجب (complete positive) is a positive sentence with a mentioned المستثنى منه (the excepted from), تام غير موجب (complete negative) is a negative sentence with a mentioned المستثنى منه, and ناقص (incomplete) is a sentence without a mentioned المستثنى منه.',
    topic: 'exceptions'
  },
  {
    id: 'ex23',
    text: 'According to Al-Ajrumiyyah, can ليس (laysa) and يكون (yakoon) be used for exception?',
    type: 'single',
    options: [
      { id: 'a', text: 'Yes, both can be used for exception', isCorrect: true },
      { id: 'b', text: 'Only ليس (laysa) can be used for exception', isCorrect: false },
      { id: 'c', text: 'Only يكون (yakoon) can be used for exception', isCorrect: false },
      { id: 'd', text: 'No, neither can be used for exception', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that both ليس (laysa) and يكون (yakoon) can be used for exception, as in جاء القوم ليس زيداً (The people came, not Zayd) and جاء القوم لا يكون زيداً (The people came, not being Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex24',
    text: 'According to Al-Ajrumiyyah, when ليس (laysa) and يكون (yakoon) are used for exception, what is the case of the noun after them?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that when ليس (laysa) and يكون (yakoon) are used for exception, the noun after them is in the accusative case, as in جاء القوم ليس زيداً (The people came, not Zayd) and جاء القوم لا يكون زيداً (The people came, not being Zayd).',
    topic: 'exceptions'
  },
  {
    id: 'ex25',
    text: 'According to Al-Ajrumiyyah, can حاشا (hasha) be used without ما (ma) and be considered a verb?',
    type: 'single',
    options: [
      { id: 'a', text: 'Yes, it can be a verb even without ما (ma)', isCorrect: true },
      { id: 'b', text: 'No, it can only be a verb when preceded by ما (ma)', isCorrect: false },
      { id: 'c', text: 'No, it is always a preposition', isCorrect: false },
      { id: 'd', text: 'No, it is always a noun', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that حاشا (hasha) can be used without ما (ma) and be considered a verb, in which case what comes after it is in the accusative case.',
    topic: 'exceptions'
  },
  {
    id: 'ex26',
    text: 'According to Al-Ajrumiyyah, what is the case of المستثنى (the excepted) in the sentence جاء القوم إلا زيداً (The people came except Zayd)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المستثنى (the excepted) in a complete positive sentence is in the accusative case, so in the sentence جاء القوم إلا زيداً (The people came except Zayd), زيداً is in the accusative case.',
    topic: 'exceptions'
  },
  {
    id: 'ex27',
    text: 'According to Al-Ajrumiyyah, what is the case of المستثنى (the excepted) in the sentence ما جاء أحد إلا زيدٌ (No one came except Zayd) when it is treated as بدل (substitution)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المستثنى (the excepted) in a complete negative sentence can be treated as بدل (substitution), in which case it takes the case of المستثنى منه (the excepted from). So in the sentence ما جاء أحد إلا زيدٌ (No one came except Zayd), زيدٌ is in the nominative case because أحد is in the nominative case.',
    topic: 'exceptions'
  },
  {
    id: 'ex28',
    text: 'According to Al-Ajrumiyyah, what is the case of المستثنى (the excepted) in the sentence ما جاء القوم إلا زيداً (The people did not come except Zayd) when it is not treated as بدل (substitution)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المستثنى (the excepted) in a complete negative sentence can be in the accusative case when it is not treated as بدل (substitution). So in the sentence ما جاء القوم إلا زيداً (The people did not come except Zayd), زيداً is in the accusative case.',
    topic: 'exceptions'
  },
  {
    id: 'ex29',
    text: 'According to Al-Ajrumiyyah, what is the case of المستثنى (the excepted) in the sentence ما جاء إلا زيدٌ (No one came except Zayd)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المستثنى (the excepted) in a negative incomplete sentence is according to what the sentence requires. So in the sentence ما جاء إلا زيدٌ (No one came except Zayd), زيدٌ is in the nominative case because it is the subject.',
    topic: 'exceptions'
  },
  {
    id: 'ex30',
    text: 'According to Al-Ajrumiyyah, what is the case of المستثنى (the excepted) in the sentence ما رأيت إلا زيداً (I did not see except Zayd)?',
    type: 'single',
    options: [
      { id: 'a', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المستثنى (the excepted) in a negative incomplete sentence is according to what the sentence requires. So in the sentence ما رأيت إلا زيداً (I did not see except Zayd), زيداً is in the accusative case because it is the object.',
    topic: 'exceptions'
  }
];
